import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <>
        <Link to='/'>Visit Our Homepage</Link>
        </>
    );
};

export default NotFoundPage;